export default function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
    const comparison = a[key].toString().localeCompare(b[key].toString());

    return order === "desc" ? comparison * -1 : comparison;
  };
}
